import type { ComponentChildren, ComponentProps } from 'preact';
import styles from './CardBackdrop.module.css';

export interface CardBackdropProps extends Omit<
  ComponentProps<'div'>,
  'children' | 'ref'
> {
  children: ComponentChildren;
  scroll?: 'y';
}

export function CardBackdrop({
  children,
  className = '',
  scroll,
  ...props
}: CardBackdropProps) {
  const scrollClassName = scroll === 'y' ? styles.scrollY : '';
  return (
    <div
      {...props}
      className={`${styles.cardBackdrop} ${scrollClassName} ${className}`.trim()}
    >
      {children}
    </div>
  );
}
